export const siteNav = [
  { label: "首页", path: "/" },
  { label: "影视作品", path: "/works" },
  { label: "资讯动态", path: "/news" },
  { label: "关于我们", path: "/about" },
];

export const heroSlides = [
  {
    id: "slide-1",
    kicker: "年度焦点 · 新剧来袭",
    title: "杨幂新剧《哈尔滨一九四四》",
    subtitle: "年代谍战全新突破，身份复杂的关雪步步为营，气场全开。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20resolute%20elegant%20woman%20in%201940s%20coat%20standing%20in%20a%20snowy%20old%20northeastern%20city%20street%2C%20dramatic%20warm%20rose%20and%20gold%20rim%20light%20against%20deep%20amber%20shadow%2C%20moody%20atmospheric%20film%20still%2C%20high%20detail&width=1600&height=900&seq=ym-hero-01&orientation=landscape",
    link: "/works/ha-er-bin-yi-jiu-si-si",
    tag: "影视作品",
  },
  {
    id: "slide-2",
    kicker: "经典回顾 · 现象级仙侠",
    title: "《三生三世十里桃花》",
    subtitle: "白浅与夜华的三生纠缠，一部被反复重温的仙侠经典。",
    image: "https://readdy.ai/api/search-image?query=Dreamy%20cinematic%20wide%20banner%20of%20a%20woman%20in%20flowing%20pale%20pink%20hanfu%20amid%20peach%20blossom%20petals%20and%20misty%20mountains%2C%20warm%20rose%20gold%20glow%2C%20ethereal%20fantasy%20film%20still%2C%20high%20detail&width=1600&height=900&seq=ym-hero-02&orientation=landscape",
    link: "/works/san-sheng-san-shi-shi-li-tao-hua",
    tag: "经典作品",
  },
  {
    id: "slide-3",
    kicker: "最新动态 · 现场直击",
    title: "杨幂亮相国际时装周",
    subtitle: "玫红色高定礼服惊艳全场，造型话题登上热搜榜。",
    image: "https://readdy.ai/api/search-image?query=Glamorous%20cinematic%20wide%20banner%20of%20a%20fashion%20week%20scene%20with%20elegant%20woman%20in%20rose%20haute%20couture%20gown%2C%20warm%20spotlights%20and%20gold%20tones%2C%20chic%20modern%20venue%2C%20editorial%20film%20still%2C%20high%20detail&width=1600&height=900&seq=ym-hero-03&orientation=landscape",
    link: "/news/yangmi-fashion-week",
    tag: "资讯动态",
  },
];

export const topics = [
  {
    id: "topic-fantasy",
    title: "古装仙侠代表作",
    desc: "从《宫锁心玉》到《三生三世十里桃花》，回顾杨幂的古装高光时刻。",
    link: "/works?type=电视剧&tag=古装",
    icon: "ri-magic-line",
  },
  {
    id: "topic-movie",
    title: "电影作品全览",
    desc: "科幻、武侠、现实题材，看杨幂如何在大银幕上不断突破自我。",
    link: "/works?type=电影",
    icon: "ri-film-line",
  },
  {
    id: "topic-news",
    title: "最新活动与访谈",
    desc: "紧跟杨幂的公开活动、幕后花絮与深度访谈，第一时间送达。",
    link: "/news",
    icon: "ri-newspaper-line",
  },
];

export const starProfile = {
  name: "杨幂",
  enName: "Yang Mi",
  intro:
    "杨幂，中国内地知名女演员。凭借《宫锁心玉》走入大众视野，此后以《三生三世十里桃花》《古剑奇谭》《扶摇》等作品持续收获高人气，并在电影领域不断挑战多元题材。她以对表演的专注和对角色的细腻理解，成为兼具话题度与作品厚度的实力派演员。",
  facts: [
    { label: "出道代表作", value: "《宫锁心玉》" },
    { label: "经典角色", value: "白浅 / 乔菲 / 关雪" },
    { label: "作品类型", value: "电视剧 · 电影" },
    { label: "活跃领域", value: "影视 · 时尚 · 公益" },
  ],
};

export const siteAbout = {
  title: "关于明星资讯平台",
  intro:
    "「杨幂明星资讯站」是一个专注于杨幂影视作品与最新动态的粉丝资讯平台。我们整理杨幂的电视剧、电影作品资料，持续跟进活动、访谈、花絮等新闻内容，希望能为关注杨幂的朋友提供一个权威、清晰、易浏览的信息入口。",
  features: [
    {
      icon: "ri-book-open-line",
      title: "影视作品库",
      desc: "按类型、年份筛选杨幂的电视剧与电影，查看导演、集数、主演与剧情简介。",
    },
    {
      icon: "ri-timer-flash-line",
      title: "动态实时跟进",
      desc: "活动、访谈、花絮分类呈现，按时间倒序更新，不错过每一条重要消息。",
    },
    {
      icon: "ri-search-eye-line",
      title: "全站搜索",
      desc: "输入关键词即可同时检索影视作品与资讯动态，快速定位想看的内容。",
    },
  ],
  contact: {
    email: "contact@yangmi-info.demo",
    weibo: "@杨幂资讯站",
    note: "本站为粉丝资讯演示平台，内容为演示数据，相关联系方式仅作展示。",
  },
  usage: [
    "在顶部搜索框输入关键词，可快速检索影视作品与最新资讯。",
    "进入「影视作品」可按类型与年份筛选，并使用最新/热门排序浏览。",
    "在「资讯动态」可选择时间区间与新闻类别，查看分类后的新闻列表。",
    "详情页底部提供相关推荐，方便继续浏览同类型内容。",
  ],
};